import { Outlet } from 'react-router-dom'

import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'

import { AdminMenu } from '../AdminMenu/index.js'
import { AdminModeOnboardingTrigger } from '../Onboarding/AdminModeOnboarding/AdminModeOnboardingTrigger.js'

export function AdminMode() {
  return (
    <AdminMenu>
      <AdminModeOnboardingTrigger />
      <Outlet />
    </AdminMenu>
  )
}

export function AdminCrumb() {
  const { Link } = useRouter()
  return (
    <Link href="/manage">
      <T id="Generics.Admin" defaultMessage="Admin" />
    </Link>
  )
}
